/**
 * Läuft die App gerade am Schreibtisch?
 *
 * Gebraucht für Handgriffe, die im Feld nichts verloren haben – Löschen vor
 * allem. Draußen, mit Handschuhen, auf einem Handy in der Jackentasche, ist
 * ein Fehlgriff zu leicht, und was gelöscht ist, ist weg.
 *
 * Zwei Merkmale, beide müssen zutreffen:
 *
 *   - Die App läuft nicht als installierte Anwendung (`standalone`). Wer sie
 *     auf dem Startbildschirm hat, hat sie zum Prüfen dort.
 *   - Der Bildschirm ist breit. Ein schmales Fenster ist ein Telefon.
 *
 * Wichtig und ausdrücklich: das ist ein Schutz gegen Versehen, keine
 * Sicherheitsgrenze. Der Server kann nicht sehen, auf welchem Gerät die App
 * läuft; wer die Adresse kennt, käme auch so heran. Die echten Grenzen –
 * wer darf löschen und was darf gelöscht werden – stehen im Server.
 */

import { useEffect, useState } from 'react'

export function amSchreibtisch(): boolean {
  if (typeof window === 'undefined') return false

  const alsApp =
    window.matchMedia?.('(display-mode: standalone)').matches ||
    // Safari auf iOS kennt display-mode nicht zuverlässig.
    (window.navigator as { standalone?: boolean }).standalone === true

  return !alsApp && window.innerWidth >= 1024
}

/**
 * Dasselbe als Hook, damit ein verkleinertes Fenster nicht unbemerkt bleibt.
 */
export function useAmSchreibtisch(): boolean {
  const [ja, setzeJa] = useState(amSchreibtisch)

  useEffect(() => {
    const nachsehen = () => setzeJa(amSchreibtisch())
    window.addEventListener('resize', nachsehen)
    return () => window.removeEventListener('resize', nachsehen)
  }, [])

  return ja
}
